module.exports = __webpack_public_path__ + "static_portal/img/report_short.a68f190d.jpg";